import { useIntl } from 'react-intl';
import { DYNAMIC_TRANSLATION_PREFIX } from '../internals/constants';
/**
 * Represents a component for dynamically formatted messages using React Intl (TranslationsProvider)
 *
 * @param translatedMessage - The message to be translated. It can be a string or an array of MessageFormatElement.
 * @param values - An object containing values to be interpolated into the message.
 *
 * @returns The translated and formatted message as a ReactNode.
 */
export const DynamicFormattedMessage = ({
  translatedMessage,
  values
}) => {
  const {
    formatMessage
  } = useIntl();
  const message = formatMessage({
    id: `${DYNAMIC_TRANSLATION_PREFIX}${translatedMessage.toString()}`,
    defaultMessage: translatedMessage
  }, values);
  return message;
};
//# sourceMappingURL=DynamicFormattedMessage.js.map